import { RefundModel } from 'api-hooks/refund/refund';
import Separator from 'components/common/separator';
import Text from 'components/elements/text';
import { CardSection, FullContainer } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import { useFieldArray, useFormContext } from 'react-hook-form';

import AddonsTourTable from './addons-tour';
import GuestDetailTable from './guest-detail';
interface Props {
  refund?: RefundModel;
}

export default function TourSaleSection(props: Props) {
  const { control } = useFormContext();
  const name = 'tourSales';
  const { fields } = useFieldArray({
    control,
    name,
    keyName: 'customId',
  });

  const { t } = useTranslation();

  if (fields.length === 0) {
    return null;
  }

  return (
    <>
      <Separator gap={24} />
      {fields.map((field, index) => {
        return (
          <CardSection key={field.customId}>
            <FullContainer>
              <Text variant="HeadingXSmall">
                {t('common:tour_participant')}
              </Text>
            </FullContainer>
            <GuestDetailTable parentIndex={index} />
            <AddonsTourTable parentIndex={index} />
          </CardSection>
        );
      })}
    </>
  );
}
